import   {bookingActive}                from '../Booking/bookingReducer'
import  {ROTA_TYPE_AVAIABLE, inPast}    from '../../lib/iprs-react-library/src/index.js';

/* 
 * Contains the source function for events in the team calendar. That is to say,
 * that, when asked by the calendar for events, it calls the API and loads them,
 * returning them as an array sent in a successCallback.
 * Putting this in a separate module makes it easier to test.
 */
const teamEventSource = ({cal: {info, successCallback, failureCallback},
                         other: { teamID, api, rotaMode, teamFilter, bookingState,
                                  appointmentTypes} }) => {
        
    if(!teamID){
        successCallback( [] )
        return
    }

    // If a booking is in progress and an app type has been selected, then this is the typeID
    const bookingAppTypeID = bookingState?.newBooking?.appointmentType?.appointmentTypeID?? 0;

    api.getTeamDiary( teamID, info.startStr, info.endStr )
        .then( r => r.apiResult )
        .then(apiResult => apiResult.filter(a => !a.Deleted ) )
        .then( apiResult => apiResult.map( a => {

            const isBooking = 0 < a.BookingID ?? 0;
            const confirmed = isBooking && a.Confirmed;
            const isAvailable = a.RotaTypeID === ROTA_TYPE_AVAIABLE;
            const display = forBackGround(a, rotaMode, bookingState);
            const caseRef = apiResult.CaseRef ?? '';

            let title = null;
            //let colour = null;
            let editable = true;
            let classNames = ["IPRSCalEvent"];
            if (isBooking) {
                classNames.push('booking');
                classNames.push(confirmed ? 'confirmed' : 'not-confirmed');
            }
            let isInPast = inPast(a.FinishTime);
            let explicitColour = '';
            if (isAvailable) {
                const appTypes = matchAppointmentTypes(appointmentTypes, a.AppointmentTypes)
                a.appointmentTypes = appTypes
                title = 'Available';
                
                editable = rotaMode;
                classNames.push("Availability");
            } else if (isBooking) {
                if (confirmed) {
                    title = '' + a.CaseRef;
                    explicitColour = a.Colour;
                } else {
                    title = 'Reserved Time';
                }
            } else { // Task
                title = a.Title;
                explicitColour = isInPast ? 'gray' : a.Colour;
            }
            const event = {
                id: a.RotaID, title, resourceId: a.PartyID,
                start: a.StartTime, end: a.FinishTime, apiEvent: a,
                backgroundColor: 'white', display, editable,
                classNames, rotaMode, isAvailable, bookingAppTypeID,
                isBooking, confirmed, isInPast, explicitColour, caseRef
            };
            
            return event;
        } ) )
        .then( r =>   successCallback( r ) )
        .catch( error =>  failureCallback( error ) )
};

/** 
 * We have an array of appointment types that are associated with a rota entry,
 * which have IDs but no titles.
 * We also have an array of appointmentTypes which contain names. Return the 
 * types that match the IDs.
 */
const matchAppointmentTypes = (appointmentTypes, appointmentTypesForRota) => {
    
    const result = appointmentTypesForRota.map( a => { 
        
        const appType   =   appointmentTypes.filter( at => at.AppointmentTypeID === a )[0];
        // If an app type has gone, it probably was deletd but still referrenced in rota
        return appType?? {
            "AppointmentTypeID": a,
            "Title": `Deleted appointment type '${a}'` 
        }
    } )
    
    return result
}

/* Allows the state of calandar events to be flipped between forground and 
 * background. Availablity is either foreground and everything else background
 * or the other way round. Thinks in the background are not selectable or 
 * editable. */
const forBackGround = (rotaApiResult, rotaMode, bookingState) => {
    
    const isAvailablity = rotaApiResult.RotaTypeID === ROTA_TYPE_AVAIABLE && !rotaApiResult.BookingID;

    const isBooking = 0 < rotaApiResult.BookingID ?? 0;
    const confirmed = rotaApiResult.Confirmed;

    /* when a booking is active everything is in background so you can only select
     * a region for the new booking. Otherwise it's rotaMode toggles between 
     * availablity and non availablity*/
    const isBackground =
        (isBooking && !confirmed) ||
        bookingActive(bookingState) ||
        (rotaMode ? !isAvailablity : isAvailablity);
    
    return (isBackground)? 'background': 'foreground'
}

export default teamEventSource;
 
//, [teamID, api, matchAppointmentTypes, rotaMode, rerender, teamFilter]);